import React from "react";
import styles from "./Manutencao.module.css";
import gear from "../../../assets/manutencao/gear.svg";
import Image from "next/future/image";

const Manutencao = () => {
  return (
    <>
      <section className={styles.manutencao}>
        <h2>Página em Manutenção...</h2>
        <div>
          <Image src={gear.src} height={100} width={100} alt="engrenagem" />
        </div>
      </section>
    </>
  );
};

export default Manutencao;
